import { isLsatCourse } from 'my-core/course-utils';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export default function CoursePurchaseCheckoutConfirmation({ course, noDialog, onClose }) {
  const isLsat = isLsatCourse(course);
  return (
    <>
      <Typography align="center" gutterBottom variant="h6">
        You&apos;ve successfully signed up for the Wizeprep {course.code} Course
      </Typography>
      {isLsat && (
        <Typography align="center">
          You should have received an email from lsac.org. To complete your registration, please use the link in that
          email to create your LSAC account.
        </Typography>
      )}
      {noDialog && (
        <Button onClick={onClose} size="large" sx={{ mt: 5, mx: 'auto', display: 'block' }} variant="contained">
          Get Started
        </Button>
      )}
    </>
  );
}
